module.exports = __webpack_public_path__ + "img/auterZl_bgc.png";